import rdwLogo from "./roofing-done-wright-logo.png";

export {
  rdwLogo,
};
